import React, { useEffect, useState } from "react";
import * as Styles from "./styles";
import Header from "./Header";
import Footer from "./Footer";

interface Props {
  onClose: () => void;
  mutate: any;
  refetch: () => void;
  isLoading: boolean;
  isSuccess: boolean;
  reset2: () => void;
}

const ZerarPVModal: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Header onClose={() => props?.onClose()} />
      <Footer
        onClose={() => props?.onClose()}
        isLoading={props?.isLoading}
        mutate={props?.mutate}
        refetch={props?.refetch}
        isSuccess={props?.isSuccess}
        reset2={props?.reset2}
      />
    </Styles.Container>
  );
};

export default ZerarPVModal;
